import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import ArrowBack from "@material-ui/icons/ArrowBack";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import AppBar from "@material-ui/core/AppBar";
import {useHistory} from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";

const useStyles = makeStyles(() => ({
  wrapper: {
    paddingRight: '10%',
    paddingLeft: '10%',

    backgroundColor: 'white',
    height: '100%'
  },
  initiativeHeader: {
    fontSize: '24px'
  }
}));



export default function SearchLayout({children}) {
  const classes = useStyles();
  const history = useHistory();

  // Methods
  const handleBackButton = () => {
    history.goBack();
  };

  return (
    <div>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleBackButton}
            className={classes.menuButton}
          >
            <ArrowBack />
          </IconButton>
          <div className={classes.initiativeHeader}> Search</div>
        </Toolbar>

      </AppBar>
      <div className={classes.wrapper}>
        {children}
      </div>
    </div>
  );
}